import initialState from '../store/initial-state'
import {
  ASSET_FAVORITES_GET_DATA,
  ASSET_FAVORITES_GET_DATA_SUCCESS,
  ASSET_FAVORITES_GET_DATA_FAILURE,
  ASSET_FAVORITES_EMPTY,
  ASSET_FAVORITES_ACTIVEVIEW,
  ASSET_FAVORITES_EDIT,
  ASSET_FAVORITES_EDIT_SUCCESS,
  ASSET_FAVORITES_EDIT_FAILURE,
  ASSET_FAVORITES_SET_SELECT,
  ASSET_FAVORITES_UNSET_SELECT,
  ASSET_FAVORITES_DELETE,
  ASSET_FAVORITES_DELETE_SUCCESS,
  ASSET_FAVORITES_DELETE_FAILURE,
  ASSET_FAVORITES_EDIT_SELECT,
  ASSET_FAVORITES_EDIT_UNSET_SELECT,
  ASSET_FAVORITES_EXPAND_SELECT,
  ASSET_FAVORITES_EXPAND_UNSET_SELECT,
  ASSET_FAVORITES_SHARE_SELECT,
  ASSET_FAVORITES_SHARE_UNSET_SELECT,
  ASSET_FAVORITES_ADD,
  ASSET_FAVORITES_ADD_SUCCESS,
  ASSET_FAVORITES_ADD_FAILURE,
  ASSET_FAVORITES_REMOVE,
  ASSET_FAVORITES_REMOVE_SUCCESS,
  ASSET_FAVORITES_REMOVE_FAILURE,
  ASSET_FAVORITES_MOVE,
  ASSET_FAVORITES_MOVE_SUCCESS,
  ASSET_FAVORITES_MOVE_FAILURE,
  ASSET_FAVORITES_CHECK_SELECT,
  ASSET_FAVORITES_UNCHECK_SELECT,
  MULTIPLE_FAVORITES_OPTIONS_ACTIVATE,
  MULTIPLE_FAVORITES_OPTIONS_DEACTIVATE,
  MULTIPLE_FAVORITES_OPTIONS_DONE,
  ASSET_FAVORITES_UPDATE_FROM_PERMISSION,
  ASSETS_FAVORITES_MULTI_DELETE,
  ASSETS_FAVORITES_MULTI_DELETE_SUCCESS,
  ASSETS_FAVORITES_MULTI_DELETE_FAILURE,
  ASSETS_FAVORITES_MULTI_MOVE,
  ASSETS_FAVORITES_MULTI_MOVE_SUCCESS,
  ASSETS_FAVORITES_MULTI_MOVE_FAILURE,
  ASSET_FAVORITES_MULTI_ADD,
  ASSET_FAVORITES_MULTI_ADD_SUCCESS,
  ASSET_FAVORITES_MULTI_ADD_FAILURE,
  ASSET_FAVORITES_MULTI_REMOVE,
  ASSET_FAVORITES_MULTI_REMOVE_SUCCESS,
  ASSET_FAVORITES_MULTI_REMOVE_FAILURE,
} from '../constants/assets-favorites-types'


export default (state = initialState.assetsFavorites, action) => {
  switch (action.type) {
    case ASSET_FAVORITES_GET_DATA:
      return {
        ...state,
        isFetching: action.payload.isFetching,
        data: action.payload.data,
        // isFetching: true,
        // data: [],
        headers: null,
        error: null
      }

    case ASSET_FAVORITES_GET_DATA_SUCCESS:
      return {
        ...state,
        workspace: action.payload.workspace,
        folderselect: action.payload.folderselect,
        page: action.payload.page,
        isFetching: false,
        data: action.payload.user.clientRole === 'admin' || action.payload.user.role === 'admin'
          ? action.payload.data
          : action.payload.data.filter(r => r.group.length > 0),
        headers: action.payload.headers,
        error: null
      }

    case ASSET_FAVORITES_GET_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        data: [],
        headers: null,
        error: action.payload
      }

    case ASSET_FAVORITES_EMPTY:
      return {
        ...state,
        isFetching: false,
        data: [],
        headers: null,
        error: null
      }

    case ASSET_FAVORITES_SET_SELECT:
      const maxItems = action.payload.from === 'vertical'
        ? action.payload.verticalCount
        : action.payload.horizontalCount
      let exist = false
      let count = 0
      return {
        ...state,
        data: [...state.data.map((r, k) => {
          let i = k + 1
          if (count >= maxItems) {
            count = 1
            exist = false
          } else {
            count++
          }
          if (!exist) exist = `${action.payload.from}-${i}` === action.payload.indice
          return {
            ...r,
            drawMiddleView: (exist && maxItems === count) || (exist && i === state.data.length),
            isSelected: r._id === action.payload.data._id,
            indice: r._id === action.payload.data._id
              ? action.payload.indice
              : null,
            from: r._id === action.payload.data._id
              ? action.payload.from
              : null
          }
        })]
      }

    case ASSET_FAVORITES_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            drawMiddleView: false,
            isSelected: false,
            indice: null,
            from: null
          }
        })]
      }

    case ASSET_FAVORITES_ACTIVEVIEW:
      return {
        ...state,
        activeView: action.payload.activeView
      }

    case ASSET_FAVORITES_EDIT:
      return {
        ...state,
        isUpdating: true,
        headers: null,
        error: null
      }

    case ASSET_FAVORITES_EDIT_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        headers: action.payload.headers,
        data: [...state.data.map(r => {
          return {
            ...r,
            indice: r._id === action.payload.data._id
              ? action.payload.indice
              : null,
            from: r._id === action.payload.data._id
              ? action.payload.from
              : null,
            name: r._id === action.payload.data._id
              ? action.payload.data.name
              : r.name,
            metadata: {
              ...r.metadata,
              descriptiveTags: r._id === action.payload.data._id
                ? action.payload.data.metadata.descriptiveTags
                : r.metadata && r.metadata.descriptiveTags ? r.metadata.descriptiveTags : [],
              createdDate: r._id === action.payload.data._id
                ? action.payload.data.metadata.createDate
                : r.metadata && r.metadata.createDate ? r.metadata.createDate : null,
              dueDate: r._id === action.payload.data._id
                ? action.payload.data.metadata.dueDate
                : r.metadata && r.metadata.dueDate ? r.metadata.dueDate : null,
            }
          }
        })]
      }

    case ASSET_FAVORITES_EDIT_FAILURE:
      return {
        ...state,
        isUpdating: false,
        headers: null,
        error: action.payload
      }

    case ASSET_FAVORITES_EDIT_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isEditSelected: r._id === action.payload.data._id,
          }
        })],
        editAssetTab: action.payload.editAssetTab
      }

    case ASSET_FAVORITES_EDIT_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isEditSelected: false,
          }
        })]
      }



    case ASSET_FAVORITES_DELETE:
      return {
        ...state,
        isFetching: true
      }

    case ASSET_FAVORITES_DELETE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        workclient: action.payload.workclient,
        data: [...state.data.filter(r => r._id !== action.payload.id)],
        error: null
      }

    case ASSET_FAVORITES_DELETE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload.error
      }

    case ASSET_FAVORITES_EXPAND_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isExpandSelected: r._id === action.payload.data._id,
          }
        })]
      }

    case ASSET_FAVORITES_EXPAND_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isExpandSelected: false,
          }
        })]
      }

    case ASSET_FAVORITES_SHARE_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isShareSelected: r._id === action.payload.data._id,
          }
        })]
      }

    case ASSET_FAVORITES_SHARE_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isShareSelected: false,
          }
        })]
      }

    case ASSET_FAVORITES_ADD:
      return {
        ...state,
        isFetching: true,
        error: null
      }

    case ASSET_FAVORITES_ADD_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: [...state.data, action.payload.data],
        error: null
      }

    case ASSET_FAVORITES_ADD_FAILURE:
      return {
        ...state,
        isFetching: true,
        error: action.payload.error
      }

    case ASSET_FAVORITES_REMOVE:
      return {
        ...state,
        isFetching: true,
        error: null
      }

    case ASSET_FAVORITES_REMOVE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: [...state.data.filter(r => r._id !== action.payload.data._id)],
        error: null
      }

    case ASSET_FAVORITES_REMOVE_FAILURE:
      return {
        ...state,
        isFetching: true,
        error: action.payload.error
      }

    case ASSET_FAVORITES_MOVE:
      return {
        ...state,
        isMoving: true,
        headers: null,
        error: null
      }

    case ASSET_FAVORITES_MOVE_SUCCESS:
      return {
        ...state,
        isMoving: false,
        headers: action.payload.headers,
        data: [...state.data.map(r => {
          return {
            ...r,
            isMoveSelected: false,
            isMoved: r._id === action.payload.data._id,
          }
        })]
      }

    case ASSET_FAVORITES_MOVE_FAILURE:
      return {
        ...state,
        isMoving: false,
        headers: null,
        error: action.payload
      }

    case ASSET_FAVORITES_CHECK_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isCheckMultiple: r._id === action.payload._id ? r.isCheckMultiple = true : r.isCheckMultiple
          }
        })]
      }

    case ASSET_FAVORITES_UNCHECK_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isCheckMultiple: r._id === action.payload._id ? r.isCheckMultiple = false : r.isCheckMultiple
          }
        })]
      }

    case MULTIPLE_FAVORITES_OPTIONS_ACTIVATE:
      return {
        ...state,
        activateMultiOptions: true
      }
    case MULTIPLE_FAVORITES_OPTIONS_DEACTIVATE:
      return {
        ...state,
        activateMultiOptions: false
      }

    case MULTIPLE_FAVORITES_OPTIONS_DONE:
      return {
        ...state,
        activateMultiOptions: false,
        data: [...state.data.map(r => {
          return {
            ...r,
            isCheckMultiple: false
          }
        })]
      }

    case ASSET_FAVORITES_UPDATE_FROM_PERMISSION:
      return {
        ...state,
        data: [
          ...state.data.map(r => {
            return r._id === action.payload._id
              ? action.payload
              : { ...r }
          })
        ]
      }
    case ASSETS_FAVORITES_MULTI_DELETE:
      return {
        ...state,
        isFetching: true
      }

    case ASSETS_FAVORITES_MULTI_DELETE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        workclient: action.payload.workclient,
        data: [...state.data.filter(r => !action.payload.ids.includes(r._id))],
        error: null
      }

    case ASSETS_FAVORITES_MULTI_DELETE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload.error
      }
    case ASSETS_FAVORITES_MULTI_MOVE:
      return {
        ...state,
        isMoving: true,
        headers: null,
        error: null
      }

    case ASSETS_FAVORITES_MULTI_MOVE_SUCCESS:
      return {
        ...state,
        isMoving: false,
        headers: action.payload.headers,
        data: [...state.data.map(r => {
          return {
            ...r,
            isMoveSelected: false,
            isMoved: action.payload.ids.includes(r._id),
          }
        })]
      }

    case ASSETS_FAVORITES_MULTI_MOVE_FAILURE:
      return {
        ...state,
        isMoving: false,
        headers: null,
        error: action.payload
      }
    case ASSET_FAVORITES_MULTI_ADD:
      return {
        ...state,
        isFetching: true,
        error: null
      }

    case ASSET_FAVORITES_MULTI_ADD_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: [...state.data, ...action.payload.data],
        error: null
      }

    case ASSET_FAVORITES_MULTI_ADD_FAILURE:
      return {
        ...state,
        isFetching: true,
        error: action.payload.error
      }

    case ASSET_FAVORITES_MULTI_REMOVE:
      return {
        ...state,
        isFetching: true,
        error: null
      }

    case ASSET_FAVORITES_MULTI_REMOVE_SUCCESS:
      const ids = action.payload.data.map(e => e._id)
      return {
        ...state,
        isFetching: false,
        data: [...state.data.filter(r => !ids.includes(r._id))],
        error: null
      }

    case ASSET_FAVORITES_MULTI_REMOVE_FAILURE:
      return {
        ...state,
        isFetching: true,
        error: action.payload.error
      }

    default: return { ...state }
  }
}
